import {
  EMAIL_SERVER_ERROR,
  PROVIDER,
  DISPLAY_NAME,
  PROFILE_PICTURE_URL,
  APPLE_PROVIDER,
  FACEBOOK_PROVIDER,
  LINE_PROVIDER,
  EMAIL_PROVIDER,
  USER_EMAIL,
  HAS_PASSWORD
} from './constant'
import { GetterTree } from 'vuex'
import { RegisterState } from './types'
import { Provider } from '@/store/api/type'

function extractDisplayName(providers: Array<Provider>, targetProvider: string): string {
  let displayName = ''
  providers.forEach(provider => {
    if (provider.provider === targetProvider) {
      displayName = provider.display_name
    }
  })
  return displayName
}

function hasPassword(providers: Array<Provider>): boolean {
  let result = false
  providers.forEach(provider => {
    if (provider.provider == 'email') {
      result = provider.has_password
    }
  })
  return result
}

export const getters: GetterTree<RegisterState, any> = {
  [EMAIL_SERVER_ERROR]: state => state.emailError,
  [PROVIDER]: state => state.provider,
  [DISPLAY_NAME]: state => state.displayName,
  [USER_EMAIL]: state => state.email,
  [PROFILE_PICTURE_URL]: state => state.profilePicURL,
  [APPLE_PROVIDER]: state => extractDisplayName(state.providers, 'apple'),
  [FACEBOOK_PROVIDER]: state => extractDisplayName(state.providers, 'facebook'),
  [LINE_PROVIDER]: state => extractDisplayName(state.providers, 'line'),
  [EMAIL_PROVIDER]: state => extractDisplayName(state.providers, 'email'),
  [HAS_PASSWORD]: state => hasPassword(state.providers)
}
